export class DomainError extends Error {
  public readonly code: string;
  public readonly details?: Readonly<object>;

  constructor(code: string, message: string, details?: object) {
    super(message);
    this.name = 'DomainError';
    this.code = code;
    if (details !== undefined) {
      this.details = Object.freeze({ ...details }) as Readonly<object>;
    }
  }
}

export class InvariantViolation extends DomainError {
  constructor(message: string, details?: object) {
    super('INVARIANT_VIOLATION', message, details);
    this.name = 'InvariantViolation';
  }
}

export class NotFound extends DomainError {
  constructor(entity: string, id: string) {
    super('NOT_FOUND', `${entity} not found: ${id}`, { entity, id });
    this.name = 'NotFound';
  }
}

export class Conflict extends DomainError {
  constructor(message: string, details?: object) {
    super('CONFLICT', message, details);
    this.name = 'Conflict';
  }
}
